module.exports = __webpack_public_path__ + "img/Cancel-Btn.4403358c.svg";